import {GetRefundStatesParams} from 'domain/usecases';
import {makeGetRefundStates} from 'main/factories/usecases';

export const getRefundStates = async (params: GetRefundStatesParams) => {
	const data = await makeGetRefundStates().get(params);

	return data.content.states;
};
